module.exports = __webpack_public_path__ + "static/media/ShoppingDay.57f1bc6d.jpg";